import dynamic from 'next/dynamic';
import type { ReactElement } from 'react';
import React from 'react';
import { ChallengeStatus } from '@engage/challenges/models';
import { useMembersRouter as useRouter } from '@members/localization/useMembersRouter';
import { Source } from '@members/pg-challenges/analytics';
import ChallengesPage from '@members/pg-challenges/ChallengesPage';

const ActiveChallenges = dynamic(
  () =>
    import('@members/pg-challenges/UpcomingActivePage').then(
      mod => mod.UpcomingActivePage,
    ),
  {
    ssr: false,
  },
);

export default function ActiveChallengesPage() {
  const router = useRouter();
  const source = router.query?.source || Source.TopNavigation;
  return (
    <ActiveChallenges
      status={ChallengeStatus.Active}
      analyticsSource={source as Source}
    />
  );
}

ActiveChallengesPage.getLayout = function getLayout(page: ReactElement) {
  return <ChallengesPage>{page}</ChallengesPage>;
};
